'use client';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useProps } from '@s7/styles';
import { IDENT, defaultProps } from './BaseButton.contract.js';
import useStyles from './BaseButton.styles.js';
import { Slot } from '../utils/RenderSlot.js';
import { UnstyledButton } from '../UnstyledButton/UnstyledButton.js';
import { toUnstyledButtonNotAllowed } from './utils/toUnstyledButtonNotAllowed/toUnstyledButtonNotAllowed.js';
import { createPolymorphicComponent } from '../utils/PolymorphicComponent/PolymorphicComponent.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const _BaseButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const _useProps = useProps(IDENT, props, defaultProps), [{ loading, loader, disabled, notAllowed, width, stretch, contentGap, children, leftSide, rightSide, className, breakpoints }, sxs] = _useProps, others = _object_without_properties_loose(_useProps[0], [
        "loading",
        "loader",
        "disabled",
        "notAllowed",
        "width",
        "stretch",
        "contentGap",
        "children",
        "leftSide",
        "rightSide",
        "className",
        "breakpoints"
    ]);
    const [classes, cx] = useStyles({
        contentGap,
        width,
        stretch,
        breakpoints
    }, sxs, IDENT);
    /*
     * `color={null}` отключает применение цвета,
     * используется currentColor, что позволяет применять цвет через стили.
     * */ const loaderSlot = /*#__PURE__*/ jsx(Slot, {
        className: classes.icon,
        color: null,
        component: loader,
        size: sxs.size
    });
    const _leftSide = loading === 'left' || loading === true ? loaderSlot : leftSide;
    const _rightSide = loading === 'right' ? loaderSlot : rightSide;
    const content = loading === 'center' ? loaderSlot : children;
    const isNotAllowed = toUnstyledButtonNotAllowed(notAllowed, disabled, !!loading);
    return /*#__PURE__*/ jsxs(UnstyledButton, _extends({}, others, {
        ref: ref,
        __wrapperAttributes: {
            'data-stretch': stretch
        },
        className: cx(classes.root, className),
        "data-disabled": disabled || undefined,
        "data-loading": !!loading,
        disabled: disabled || !!loading,
        notAllowed: isNotAllowed,
        "data-button": true,
        children: [
            _leftSide && /*#__PURE__*/ jsx("span", {
                className: cx(classes.icon, classes.leftIcon),
                children: _leftSide
            }),
            content,
            _rightSide && /*#__PURE__*/ jsx("span", {
                className: cx(classes.icon, classes.rightIcon),
                children: _rightSide
            })
        ]
    }));
});
const BaseButton = createPolymorphicComponent(_BaseButton);
BaseButton.displayName = IDENT;
var BaseButton$1 = BaseButton;

export { BaseButton, BaseButton$1 as default };
//# sourceMappingURL=BaseButton.js.map
